import {translation} from "@2d-front-monorepo/core";
import {BackButton, MaterialIcon} from "@2d-front-monorepo/design-library";
import {JSX} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

export function PermitsBackButton({small, href}: { small?: boolean, href?: string }): JSX.Element {
	return <BackButton small={small ?? false} href={href}><MaterialIcon icon="arrow_back"/>{translation(PermitTranslations.back)}</BackButton>;
}

export function PermitsBackButtonFrame({href} : { href?: string }): JSX.Element {
	return <div className="form__buttons form__buttons--bottom form__buttons--center">
		<PermitsBackButton small={true} href={href} />
	</div>;
}
